export default "__VITE_ASSET__URMeeYui__"